<style>
#AddInspection .v--modal-box.v--modal {
  min-height: 340px !important;
  min-width: 440px !important;
}
#addInspectionCardModal .placeholder--right .v-text-field__slot input,
#addInspectionCardModal .placeholder--right div.v-select__slot,
#addInspectionCardModal .placeholder--right div.v-select__slot > label,
#addInspectionCardModal .placeholder--right .v-text-field__slot label,
#addInspectionCardModal .placeholder--right .v-select__selections,
#addInspectionCardModal
  .placeholder--right
  .v-select__selection.v-select__selection--comma {
  font-size: 12px !important;
  text-align: right !important;
}
#addInspectionCardModal .tile-title {
  line-height: 34px !important;
}
#addInspectionCardModal .v-avatar {
  height: 20px !important;
  width: 20px !important;
}
#addInspectionCardModal * {
  font-size: 12px;
}
#addInspectionCardModal .checkbox--big i {
  font-size: 20px;
}
#addInspectionCardModal .subheader--lower {
  height: 30px;
}
#addInspectionCardModal .placeholder--right div::before {
  border: none;
}
#addInspectionCardModal .placeholder--right {
  padding-top: 0px;
}
</style>

<template>
  <Modal
    modalName="addInspectionCardModal"
    title="Dodaj archiwalną kartę przeglądu"
    @saved="addInspectionCard()"
    @opened="getUsers()"
    @closed="closed()"
    :module="module"
    v-if="hydrantData"
  >
    <div>
      <v-subheader class="font--primary subheader--lower"
        >Dane techniczne hydrantu</v-subheader
      >
      <v-layout style="margin-top: 0px;">
        <v-flex xs5>
          <v-text-field
            label="ID hydrantu"
            height="16"
            readonly
            v-model="hydrantData.id"
          >
          </v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-text-field
            label="Numer eksploatalcyjny"
            height="16"
            readonly
            v-model="hydrantData.exploitation"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs5>
          <v-text-field
            label="Status hydrantu"
            height="16"
            readonly
            v-model="hydrantData.status"
          >
          </v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-text-field
            label="Rodzaj hydrantu"
            height="16"
            readonly
            v-model="hydrantData.hydrant_kind"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs5>
          <v-text-field
            label="Producent"
            height="16"
            readonly
            v-model="hydrantData.producer"
          >
          </v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-text-field
            label="Data wykonania ostatniego przeglądu"
            height="16"
            readonly
            v-model="lastInspectionDate"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-form v-model="valid" ref="form">
        <div>
          <v-subheader class="font--primary subheader--lower"
            >Określenie parametrów przeglądu</v-subheader
          >
          <!-- <v-layout
            v-if="!archive"
            style="margin-top: 5px;"
          >
            <v-flex xs12>
              <v-text-field
                v-model="inspectionDataCopy.task_id"
                readonly
                label="ID zadania, w ramach którego wykonano przegląd"
                height="16"
              >
              </v-text-field>
            </v-flex>
          </v-layout> -->
          <v-layout>
            <v-flex xs5>
              <v-select
                height="16"
                :items="usersList"
                item-text="name"
                :return-object="true"
                no-data-text="Brak użytkowników"
                label="Pracownik wykonujący przegląd"
                v-model="chosenWorker"
              />
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-menu
                :close-on-content-click="false"
                v-model="menuDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  height="16"
                  slot="activator"
                  v-model="dateFormatted"
                  label="Data wykonania przeglądu"
                  @input="
                    inspectionData.inspection_date = parseDate(dateFormatted)
                  "
                >
                </v-text-field>
                <v-date-picker
                  v-model="inspectionData.inspection_date"
                  @input="menuDate = false"
                  color="#2a579a"
                  locale="pl-pl"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-list style="width: 100%">
            <v-list-tile
              class="list--el"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content
                @click="
                  inspectionData.external_examination = !inspectionData.external_examination
                "
              >
                <v-list-tile-title
                  >Oględziny zewnętrzene hydrantu</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox
                  class="checkbox--big"
                  v-model="inspectionData.external_examination"
                ></v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              class="list--el"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content
                @click="inspectionData.startup = !inspectionData.startup"
              >
                <v-list-tile-title
                  >Uruchomienie/przepłukanie hydrantu</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox
                  class="checkbox--big"
                  v-model="inspectionData.startup"
                ></v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              class="list--el"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content
                @click="
                  inspectionData.static_pressure = !inspectionData.static_pressure
                "
              >
                <v-list-tile-title
                  >Pomiar ciśnienia statycznego</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox
                  class="checkbox--big"
                  v-model="inspectionData.static_pressure"
                ></v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              class="list--el"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content
                @click="
                  inspectionData.dynamic_pressure = !inspectionData.dynamic_pressure
                "
              >
                <v-list-tile-title
                  >Pomiar ciśnienia dynamicznego</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox
                  class="checkbox--big"
                  v-model="inspectionData.dynamic_pressure"
                ></v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              class="list--el"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content
                @click="inspectionData.flow_rate = !inspectionData.flow_rate"
              >
                <v-list-tile-title>Pomiar natężenia wypływu</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox
                  class="checkbox--big"
                  v-model="inspectionData.flow_rate"
                ></v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              class="list--el"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content
                @click="inspectionData.abduction = !inspectionData.abduction"
              >
                <v-list-tile-title
                  >Sprawdzenie skuteczności odwodnienia</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox
                  class="checkbox--big"
                  v-model="inspectionData.abduction"
                ></v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>
        <v-layout>
          <v-list subheader style="width: 100%">
            <v-subheader class="font--primary">Pomierzone wartości</v-subheader>
            <v-list-tile style="border-bottom: 1px solid lightgrey">
              <v-list-tile-content>
                <v-list-tile-title
                  >Wartość zmierzonego ciśnienia statycznego</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-text-field
                  height="16"
                  placeholder="Wpisz wartość [MPa]"
                  single-line
                  class="placeholder--right"
                  v-model="inspectionData.static_pressure_value"
                  hide-details
                ></v-text-field>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile style="border-bottom: 1px solid lightgrey">
              <v-list-tile-content>
                <v-list-tile-title
                  >Wartość zmierzonego ciśnienia dynamicznego</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-text-field
                  height="16"
                  class="placeholder--right"
                  placeholder="Wpisz wartość [MPa]"
                  v-model="inspectionData.dynamic_pressure_value"
                  hide-details
                ></v-text-field>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile style="border-bottom: 1px solid lightgrey">
              <v-list-tile-content>
                <v-list-tile-title
                  >Wartość natężenia wypływu z hydrantu</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-text-field
                  class="placeholder--right"
                  height="16"
                  placeholder="Wpisz wartość [l/s]"
                  v-model="inspectionData.flow_rate_value"
                  hide-details
                ></v-text-field>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-layout>
        <v-layout>
          <v-flex class="comment__container">
            <v-subheader class="font--primary"
              >Komentarze do przeglądu</v-subheader
            >
            <v-flex xs12>
              <v-textarea
                outline
                name="comment"
                v-model="inspectionData.comments"
              >
              </v-textarea>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-form>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    objectTable: "inspections",
    objectType: "inspections",
    module: "inspections",
    dateFormatted: null,
    modalDate: false,
    menuDate: false,
    chosenWorker: undefined,
    hydrantData: {},
    inspectionData: {
      abduction: false,
      comments: "",
      dynamic_pressure: false,
      dynamic_pressure_value: "",
      external_examination: "",
      flow_rate: false,
      flow_rate_value: "",
      hydrant: "",
      inspection_date: null,
      inspection_id: "",
      startup: false,
      static_pressure: false,
      static_pressure_value: "",
      user_id: ""
    },
    lastInspectionDate: null,
    usersList: [],
    valid: false,
    archive: false
  }),
  watch: {
    "inspectionData.inspection_date"(val) {
      this.dateFormatted = this.formatDate(this.inspectionData.inspection_date);
    }
  },
  computed: {
    inspectionCards() {
      return this.$store.getters.getInspectionCards;
    }
    // hydrantData() {
    //   if(this.$store.getters.getHydrantData) {
    //     let data = this.$store.getters.getHydrantData.values_;
    //     if(data && data.last_inspection_date) {
    //       data.last_inspection_date = this.formatDate(data.last_inspection_date.slice(0, 10))
    //     }
    //     return data
    //   }
    // }
  },
  methods: {
    addInspectionCard() {
      let payload = this.inspectionData;
      payload.hydrant = this.hydrantData.id;
      payload.user_id = this.chosenWorker.id;
      this.$store
        .dispatch("addHydrantInspection", payload)
        .then(success => {
          if (success) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dodano kartę przeglądu"
            );
            this.$root.$emit("edited_inspection");
            // this.getInspectionCards()
            this.$modal.hide("addInspectionCardModal");
            this.$ro;
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas dodawania karty przeglądu wystąpił błąd"
            );
          }
        })
        .catch(err => {
          this.$root.$emit("showSnackbar", "success", `${err}`);
        });
    },
    getInspectionCards() {
      this.$store
        .dispatch("getInspectionCards", {
          hydrant: this.hydrantData.id,
          last_only: false
        })
        .then(success => {
          if (success) {
            return true;
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas pobierania zadania wystąpił błąd"
            );
          }
        });
    },
    closed() {
      this.hydrantData = {};
      this.inspectionData = {};
      this.chosenWorker = undefined;
      this.usersList = [];
      this.editing = false;
    },
    getUsers() {
      this.$store.dispatch("getUsers").then(r => {
        if (r) {
          this.usersList = this.$store.getters.getUsers.map(user => {
            return {
              name: user.name,
              id: user.id
            };
          });
        } else {
          return false;
        }
      });
    },
    formatDate(date) {
      if (!date) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    },
    parseDate(date) {
      if (!date) {
        return null;
      } else {
        const [day, month, year] = date.split(".");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
    validate() {
      //uzupełnić walidację
      return true;
    },
    setData(data) {
      this.hydrantData = data;
      if (this.hydrantData.last_inspection_date) {
        this.lastInspectionDate = this.formatDate(
          this.hydrantData.last_inspection_date.slice(0, 10)
        );
      }
      this.inspectionData.hydrant = data.id;
    }
  },
  mounted() {
    this.$root.$on("addArchiveInspectionCard", this.setData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/hydrants/modals/inspections/AddInspectionCard.vue